export default "__VITE_ASSET__ZEGexpfQ__"